import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import MemberPrivateRoute from './MemberPrivateRoute';
import MemberPublicRoute from './MemberPublicRoute';

// Layouts
import PublicLayout from '../components/layouts/PublicLayout';
import AdminLayout from '../components/layouts/AdminLayout';
import MemberLayout from '../components/layouts/MemberLayout';

// Public Pages
import Home from '../pages/public/Home';
import Transparency from '../pages/public/Transparency';
import Calendar from '../pages/public/Calendar';
import About from '../pages/public/About';

// Auth Pages
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';

// Admin Pages
import Dashboard from '../pages/admin/Dashboard';
import MembersList from '../pages/admin/Members/MembersList';

// Users Pages
import UsersList from '../pages/admin/Users/UsersList';
import UserCreate from '../pages/admin/Users/UserCreate';
import UserEdit from '../pages/admin/Users/UserEdit';
import CompletePhoto from '../pages/admin/Users/CompletePhoto';

// Expenses Pages
import ExpensesList from '../pages/admin/Expenses/ExpensesList';
import ExpenseCreate from '../pages/admin/Expenses/ExpenseCreate';
import ExpenseEdit from '../pages/admin/Expenses/ExpenseEdit';

// Events Pages
import EventsList from '../pages/admin/Events/EventsList';
import EventCreate from '../pages/admin/Events/EventCreate';
import EventEdit from '../pages/admin/Events/EventEdit';

// Member Pages
import MemberLogin from '../pages/member/Login';
import MemberRegister from '../pages/member/Register';
import MemberForgotPassword from '../pages/member/ForgotPassword';
import MemberResetPassword from '../pages/member/ResetPassword';
import MemberDashboard from '../pages/member/Dashboard';
import MemberProfile from '../pages/member/Profile';
import MemberCompletePhoto from '../pages/member/CompletePhoto';

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/transparencia" element={<Transparency />} />
          <Route path="/calendario" element={<Calendar />} />
          <Route path="/sobre" element={<About />} />
        </Route>

        {/* Auth Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route path="/esqueci-senha" element={<ForgotPassword />} />
        <Route path="/redefinir-senha" element={<ResetPassword />} />

        {/* Admin - Completar cadastro (foto obrigatória, fora do layout) */}
        <Route
          path="/admin/completar-cadastro"
          element={
            <PrivateRoute>
              <CompletePhoto />
            </PrivateRoute>
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />

          {/* Members Routes - admin and secretaria */}
          <Route
            path="associados"
            element={
              <PrivateRoute allowedRoles={['admin', 'secretaria']}>
                <MembersList />
              </PrivateRoute>
            }
          />

          {/* Expenses Routes - any authenticated user */}
          <Route path="despesas" element={<ExpensesList />} />
          <Route path="despesas/nova" element={<ExpenseCreate />} />
          <Route path="despesas/:id" element={<ExpenseEdit />} />

          {/* Calendar Routes - admin only */}
          <Route
            path="calendario"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <EventsList />
              </PrivateRoute>
            }
          />
          <Route
            path="calendario/novo"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <EventCreate />
              </PrivateRoute>
            }
          />
          <Route
            path="calendario/:id"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <EventEdit />
              </PrivateRoute>
            }
          />

          {/* Users Routes - admin and secretaria only */}
          <Route
            path="usuarios"
            element={
              <PrivateRoute allowedRoles={['admin', 'secretaria']}>
                <UsersList />
              </PrivateRoute>
            }
          />
          <Route
            path="usuarios/novo"
            element={
              <PrivateRoute allowedRoles={['admin', 'secretaria']}>
                <UserCreate />
              </PrivateRoute>
            }
          />
          <Route
            path="usuarios/:id"
            element={
              <PrivateRoute allowedRoles={['admin', 'secretaria']}>
                <UserEdit />
              </PrivateRoute>
            }
          />
        </Route>

        {/* Member Auth Routes */}
        <Route
          path="/associado/login"
          element={
            <MemberPublicRoute>
              <MemberLogin />
            </MemberPublicRoute>
          }
        />
        <Route
          path="/associado/cadastro"
          element={
            <MemberPublicRoute>
              <MemberRegister />
            </MemberPublicRoute>
          }
        />
        <Route path="/associado/esqueci-senha" element={<MemberForgotPassword />} />
        <Route path="/associado/redefinir-senha" element={<MemberResetPassword />} />

        {/* Associado - Completar cadastro (foto obrigatória, fora do layout) */}
        <Route
          path="/associado/completar-cadastro"
          element={
            <MemberPrivateRoute>
              <MemberCompletePhoto />
            </MemberPrivateRoute>
          }
        />

        {/* Member Protected Routes */}
        <Route
          path="/associado"
          element={
            <MemberPrivateRoute>
              <MemberLayout />
            </MemberPrivateRoute>
          }
        >
          <Route index element={<Navigate to="/associado/dashboard" replace />} />
          <Route path="dashboard" element={<MemberDashboard />} />
          <Route path="perfil" element={<MemberProfile />} />
        </Route>

        {/* 404 - Redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
